import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ADVENTURES } from "../data/content";
import { FadeUp, SectionHead, Img } from "./Reveal";

export const Adventure = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="adventure" data-testid="adventure-section" ref={ref} className="relative py-24 lg:py-36 bg-forest-900/40 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-start">
          <div>
            <SectionHead
              num="04"
              eyebrow="Adventure"
              title="Chase Adventure"
              copy="Beyond the safari track — ridges, rivers, night skies and the open road."
            />
            <div className="mt-12 flex flex-col">
              {ADVENTURES.map((a, i) => (
                <FadeUp key={a.name} delay={i * 0.05}>
                  <div
                    data-testid={`adventure-item-${a.name.toLowerCase().replace(/\s+/g, "-")}`}
                    className="group flex items-baseline gap-6 py-5 border-b border-gold/10 hover:border-gold/40 transition-colors duration-500 cursor-default"
                  >
                    <span className="font-mono text-xs text-gold/60">0{i + 1}</span>
                    <div>
                      <h3 className="font-serif text-xl sm:text-2xl text-cream group-hover:text-gold transition-colors duration-300">
                        {a.name}
                      </h3>
                      <p className="text-sm text-fog mt-1 group-hover:text-sage transition-colors duration-300">
                        {a.desc}
                      </p>
                    </div>
                  </div>
                </FadeUp>
              ))}
            </div>
          </div>

          <FadeUp delay={0.15} className="lg:sticky lg:top-28">
            <div className="relative h-[420px] lg:h-[560px] overflow-hidden">
              <motion.div style={{ y }} className="absolute -inset-y-12 inset-x-0">
                <Img
                  src={ADVENTURES[4].img}
                  alt="Wildlife expedition"
                  className="w-full h-full object-cover"
                />
              </motion.div>
              <div className="absolute inset-0 bg-gradient-to-t from-forest-950/80 via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6 right-6">
                <p className="font-serif italic text-xl text-cream/90 leading-snug">
                  "The forest does not perform. It reveals."
                </p>
                <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold mt-2 block">
                  Field notes · Satpura
                </span>
              </div>
            </div>
          </FadeUp>
        </div>
      </div>
    </section>
  );
};
